<template>
  <div class="md-layout text-center">
    <div
      v-if="cmd == 'activate'"
      class="md-layout-item md-size-33 md-medium-size-50 md-xsmall-size-100">
        <md-card>
            <md-card-header class="md-card-header-blue">
              <h3 class="title">
                <img :src="logo" />
                Bestätigung
              </h3>
            </md-card-header>
            <md-card-content>
              Danke für deine Bestätigung,<br>dein Benutzer ist jetzt erfolgreich aktiviert!
            </md-card-content>
        </md-card>
        <router-link to="/Login"
          ><md-button class="md-primary"
            >Jetzt anmelden!</md-button
          ></router-link
        >
    </div>
    <div
      v-if="cmd == 'unsubscribe'"
      class="md-layout-item md-size-33 md-medium-size-50 md-xsmall-size-100">
        <md-card>
            <md-card-header class="md-card-header-blue">
              <h3 class="title">
                <img :src="logo" />
                Abmeldung
              </h3>
            </md-card-header>
            <md-card-content>
              Du hast dich vom Newsletter abgemeldet!
            </md-card-content>
        </md-card>
        <router-link to="/Login"
          ><md-button class="md-primary"
            >Jetzt anmelden!</md-button
          ></router-link
        >
    </div>
    <div
      v-else-if="cmd == 'register'"
      class="md-layout-item md-size-33 md-medium-size-50 md-xsmall-size-100"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-blue">
              <h3 class="title">
                <img :src="logo" />
                Tritt noch heute <br />Sports4me bei, es ist kostenlos.
              </h3>
            </md-card-header>

            <md-card-content>
              <ValidationProvider
                name="displayName"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Benutzername</label>
                  <md-input v-model="displayName" type="text"></md-input>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Email Adresse</label>
                  <md-input v-model="email" type="email"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                name="password"
                rules="required|confirmed:confirmation|min:5"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Kennwort</label>
                  <md-input v-model="password" type="password"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                vid="confirmation"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Kennwort wiederholen</label>
                  <md-input v-model="confirmation" type="password"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </md-card-content>

            <md-card-actions>
              <md-button type="submit" class="md-success">Beitreten</md-button>
            </md-card-actions>
            <p>
              Mit der Registrierung bei Sports4me stimmst du den
              Nutzungsbedingungen zu. Schau dir unsere
              <a href="https://www.sports4me.at/datenschutz/">Datenschutz-Bestimmungen</a>
              an.
            </p>
          </md-card>
        </form>
        <p>Du hast schon einen Account?</p>
        <router-link to="/Login"
          ><md-button class="md-primary"
            >Jetzt anmelden!</md-button
          ></router-link
        >
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";

extend("email", email);
extend("required", required);
extend("confirmed", confirmed);

export default {
  mounted() {
    let query = this.$route.query;
    if (query && query.cmd) {
      this.cmd = query.cmd;
      if (query.u && (query.cmd == "activate" || query.cmd == "unsubscribe")) {
        this.$store.dispatch("register", {cmd: query.cmd, token: query}).then((r) => {
          let msg = "Deine Anfrage wurde erfolgreich durchgeführt!";
          if(r.cmd && r.cmd == "activate") {
            msg = "Danke für deine Bestätigung!"
          }
          if(r.cmd && r.cmd == "unsubscribe") {
            msg = "Du hast dich erfolgreich vom Newsletter abgemeldet!"
          }
          this.$notify({
            timeout: 5000,
            message: msg,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
        });
      }
    } else {
      this.cmd = "register";
    }
  },
  data() {
    return {
      cmd: null,
      email: "",
      password: "",
      confirmation: "",
      displayName: ""
    };
  },
  props: {
    logo: {
      type: String,
      default: "/img/sports4me.svg"
    }
  },
  methods: {
    submit() {
      let displayName = this.displayName;
      let email = this.email;
      let password = this.password;
      this.$store
        .dispatch("register", { displayName, email, password })
        .then(() => {
          // Send user to Dashboard after successful register
          this.$router.push("/").catch(err => {
            console.log(err);
            throw new Error(`Problem handling something: ${err}.`);
          });
          // Tell user he's registered
          this.$notify({
            timeout: 5000,
            message: "Du bist jetzt registriert!",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          if (err.response.status === 400) {
            this.$notify({
              timeout: 5000,
              message: "Du hast schon ein Konto!",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
          console.log(err.response.status);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
